import React from 'react';

import FolxLoader from '@ui/atoms/FolxLoader';

import { useAuth } from './AuthProvider';

export const AuthGate = ({ children }: { children: JSX.Element }) => {
	const { initialized } = useAuth();

	return initialized ? children : <FolxLoader message="Initializing user..." />;
};
